import { createSlice } from "@reduxjs/toolkit";
import { IShelfPlanInformation, IShelfPlanAdminCost, IAutoPlanRate } from "components/auto/shelfPlans/information/Information.interface";
import { IAutoPlanServiceRateConfiguration } from "container/auto/planSetup/b2c/shelfPlans/services/shelfPlanService.interface";
import { RootState } from "redux/store";
import { SALE_POINTS } from "shared/constant";
import { IListOfValues } from "shared/interface/types";

interface IAutoInitialState {
  ShelfPlan: IShelfPlanInformation;
  ShelfPlanAdminCost: IShelfPlanAdminCost;
  AutoPlanRateConfiguration: IAutoPlanRate[];
  AutoPlanService: {
    id: string;
    autoPlanServiceRateConfiguration?: IAutoPlanServiceRateConfiguration[];
    service?: { contribution: IListOfValues; id: number; name: string };
  };
  AutoPlanActivePlans: string[];
  ActivePriceSalePoint: keyof typeof SALE_POINTS;
}

const initialState: IAutoInitialState = {
  ShelfPlan: {
    name: "",
    productName: "",
    heading: "",
    description: "",
    videoUrl: "",
    instantCoverNote: false,
    takafulProviderId: "",
    category: "",
    planTypeId: 0,
    taxTypeId: 0,
    stateIds: [0],
    taxType: {
      key: "",
      value: ""
    },
    state: [],
    planType: {
      id: 0,
      value: ""
    },
    takafulProvider: {
      id: "",
      companyName: ""
    }
  },
  ShelfPlanAdminCost: {
    adminCostMax: 0,
    adminCostMaxTypeId: 0,
    adminCostMin: 0,
    adminCostMinTypeId: 0
  },
  AutoPlanActivePlans: [],
  AutoPlanRateConfiguration: [],
  AutoPlanService: {
    id: ""
  },
  ActivePriceSalePoint: ""
};

const autoSlice = createSlice({
  name: "auto",
  initialState,
  reducers: {
    AddAutoShelfPlan: (state, action) => {
      state.ShelfPlan = action.payload;
    },
    DeleteAutoShelfPlan: state => {
      state.ShelfPlan = initialState.ShelfPlan;
    },
    UpdateAdminCostForShelfPlanPrice: (state, action) => {
      state.ShelfPlanAdminCost = action.payload;
    },
    AddAutoPlanService: (state, action) => {
      state.AutoPlanService = action.payload;
    },
    UpdateAutoActivePlan: (state, action) => {
      state.AutoPlanActivePlans = action.payload;
    },
    UpdateAutoPlanRateConfiguration: (state, action) => {
      state.AutoPlanRateConfiguration = action.payload;
    },
    UpdateActiveSalePoint: (state, action) => {
      state.ActivePriceSalePoint = action.payload;
    }
  }
});

export const {
  AddAutoShelfPlan,
  DeleteAutoShelfPlan,
  UpdateAdminCostForShelfPlanPrice,
  UpdateAutoPlanRateConfiguration,
  UpdateAutoActivePlan,
  AddAutoPlanService,
  UpdateActiveSalePoint
} = autoSlice.actions;
export default autoSlice.reducer;
export const getAutoShelfPlan = (state: RootState): IAutoInitialState => state.auto;
